import React, { FC } from "react";

import { Props, defaultData } from "./types";

const Message: FC<Props> = ({ data = defaultData }) => (
  <div className="Message" style={{ paddingLeft: '20px', textAlign: 'left' }}>
    {data.messages[0]}
  </div>
);

export default Message;
